<div class="layout-sidebar-large layout-shopkeeper">

  <app-shopkeeper-header></app-shopkeeper-header>

  <div class="main-content-wrap shopkeeper-main-content d-flex flex-column" style="padding-bottom: 100px; position: relative;">
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <!-- <app-page-skeleton *ngIf="moduleLoading"></app-page-skeleton> -->
  </div>
  <app-footer></app-footer>
</div>